import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IUsersMeApiResponse, IUsersMeApiUser } from '../types/UsersMe.api';
import { USERS_ME_PATH } from './authServiceApiBase';

/**
 * Reads the signed-in person. The subject is the token, so the selected
 * office's `x-office` header is stripped rather than sent along.
 */
export const getMe = async (): Promise<IUsersMeApiUser> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.get<IUsersMeApiResponse>(USERS_ME_PATH, {
    headers: { ...headers, 'x-office': undefined },
  });
  return data.data;
};
